<ng-container *ngIf="plusCardData$ | async as plusCardData">
  <div #plusCard class="plus-card relative" [style.fontSize.px]="fontSize$ | async" data-testid="plus-card">
    <div class="absolute top-left fill grow">
      @if (enableGoldGradient && plusCardData.cardTier === ProfileTier.GOLD) {
        <div class="gold-content absolute fill grow flex flex--column nordic-blue-900-text text-icon-primary">
          <div class="gold-header flex flex--space-between">
            <fcom-icon
              class="gold-logo"
              [category]="IconLibrary.SVG_LIBRARY"
              [name]="SvgLibraryIcon.FINNAIR_PLUS"
              [dataTestId]="'gold-card-logo'"
            />
            <span class="gold-tier-label" data-testid="card-tier-name">{{
              TIER_DATA_MAP[plusCardData.cardTier]?.tierName
            }}</span>
          </div>
          <div class="gold-footer flex flex-1 flex--align-end">
            <div class="gold-name-number flex flex--column">
              <span class="gold-name overflow-hidden" data-testid="card-member-name">{{
                plusCardData.firstName + ' ' + plusCardData.lastName
              }}</span>
              <span class="gold-number" data-testid="member-number-formatted">{{
                plusCardData.memberNumberFormatted
              }}</span>
            </div>
          </div>
        </div>
      } @else {
        <div
          [ngClass]="{ 'white-text text-icon-reversed': !plusCardData.isStartingTier }"
          class="content absolute fill grow flex flex--column white-text text-icon-reversed"
        >
          <!--
		Apparently the dynamic labels could be directly modified in the SVG, which could really simplify this component.
		Just not sure about the multiline member name with ellipsis, but if you read this and have the time, try doing that.
	-->
          <div class="align-center light-type">
            <span class="plus-card-tier-name" data-testid="card-tier-full-name">{{
              plusCardData.cardTierFullName
            }}</span>
            <br />
            <span class="plus-card-member-number" data-testid="member-number-formatted">{{
              plusCardData.memberNumberFormatted
            }}</span>
          </div>
          <div class="plus-card-member-name flex flex-1 flex--align-end">
            <span class="overflow-hidden">{{ plusCardData.firstName + ' ' + plusCardData.lastName }}</span>
          </div>
        </div>
      }

      <div
        class="logos absolute fill flex flex--end"
        [class.logos-gold]="enableGoldGradient && plusCardData.cardTier === ProfileTier.GOLD"
        data-testid="logos"
      >
        <div *ngIf="aviosLogo$ | async as aviosLogo" class="avios-logo">
          <fcom-image [imageData]="aviosLogo" [scale]="false" [ratio]="'ORIGINAL'" [alt]="aviosLogo.alt" />
        </div>
        <div *ngIf="oneworldLogo$ | async as oneworldLogo" class="oneworld-logo">
          <fcom-image [imageData]="oneworldLogo" [scale]="false" [ratio]="'ORIGINAL'" [alt]="oneworldLogo.alt" />
        </div>
      </div>

      <fcom-icon
        *ngIf="!(enableGoldGradient && plusCardData.cardTier === ProfileTier.GOLD)"
        class="plus-card-bg-icon"
        [category]="IconLibrary.CUSTOM"
        [dataTestId]="'plus-card-bg'"
        [name]="TIER_DATA_MAP[plusCardData.cardTier]?.cardIcon"
      />
      <img
        *ngIf="enableGoldGradient && plusCardData.cardTier === ProfileTier.GOLD"
        class="plus-card-bg-img"
        data-testid="plus-card-bg"
        src="/assets/loyalty-plus/plus-card-gold-v2.svg"
        alt=""
      />
    </div>
  </div>
  <span
    class="block font-body-1 grey-500-text text-icon-disabled-text regular-type ms-small-t font-body-medium"
    *ngIf="showCardExpirationDateIfApplicable && !plusCardData.isStartingTier && !plusCardData.cardLifetimeTierFlag"
    data-testid="card-expiration-date"
    >{{ 'plus.dashboard.expires' | finLocalization }}
    {{ plusCardData.cardExpirationDate | finDateFormat: 'DATE' }}
  </span>
</ng-container>
